import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef, } from 'primeng/dynamicdialog';
import { EmsServicesService } from 'src/app/module/ems-master/services/ems-services.service';
import { SharedService } from 'src/app/shared/shared.service';
import { ordersService } from '../../services/orders.service';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { RegisterService } from 'src/app/auth/container/registration-module/register.service';
import { ServicesService } from 'src/app/module/shared/services/services.service';
import { STATUS } from 'src/app/constants/status.constant';
import { Router } from '@angular/router';
interface Warehouse {
  id: number; // or string
  name: string;
}
interface JobCreate {
  // id: any;
  fromDate: string | null;
  toDate: string | null;
  accountId: any;
  customerWarehouseId: number | undefined;
  remarks: string | null | undefined;
  contactName: string | null | undefined;
  contactMobile: string | null | undefined;
  contactAlternateMobile: string | null | undefined;
  contactEmail: string | null | undefined;
  status: string;
  jobLineItems?: any[];
  draftJobId:string,
}

@Component({
  selector: 'app-add-orders',
  templateUrl: './add-orders.component.html',
  styleUrls: ['./add-orders.component.css'],
})
export class AddordersComponent {
  rangeDates: Date[] | undefined;
  createForm = new FormGroup({
    remarks: new FormControl(null),
    tonnage: new FormControl(null),
    placementDate: new FormControl(null),
    materialType: new FormControl(null),
    // jobCode: new FormControl(null, Validators.required),
    // accountId: new FormControl(null, Validators.required),
    // customerWarehouseId: new FormControl(
    //   null as Warehouse | null,
    //   Validators.required
    // ),
    contactName: new FormControl(null, Validators.required),
    contactMobile: new FormControl(null, Validators.required),
    contactAlternateMobile: new FormControl(null),
    contactEmail: new FormControl(null, Validators.required),
    // dateRange: new FormControl<Date[] | null>(null, Validators.required),
    // vendorId: new FormControl([]),
    // contactEmail: new FormControl(null, Validators.required),
  });
  state: any;
  city: any;
  roleList: any;
  warehouseList: any;
  getWarehouseList: any;
  zone: any;
  accountList: any;
  accountMappingList: any;
  expenseAssociated: any;
  warehouseTypeList: any;
  editTrue: boolean = false;
  EditData: any;
  progress = 0;
  multipleEdit = false;
  ref: any;
  allCatagory: any;
  orderData:any;

  routeForm: FormGroup;
  manpowerList: any[] = [];
  manpowerTypes = ['Picker', 'Packer', 'Loader', 'Supervisor'];
  editIndex: number | null = null;
  customerDetails: any;
  UserDetails: any;
  accountIds: any;
  filters: any[] = [];
  sendCatagoryId: (number | undefined)[];
  skillSetList: any;
  vendorInfo: any;
  isOrderSubmitSuccessfully: boolean | any;
  jobLineItem: any;
  // constructor(private fb: FormBuilder) {

  // }
  minDate: Date = new Date();
  vehicleTypeList: any;

  constructor(
    private emsServices: EmsServicesService,
    private fb: FormBuilder,
    public dialogService: DialogService,
    public dialogRef: DynamicDialogRef,
    public data: DynamicDialogConfig,
    public messageService: MessageService,
    public sharedService: SharedService,
    public ordersService: ordersService,
    private registerService: RegisterService,
    private service: ServicesService,
    private datePipe: DatePipe,
    private _route: Router
  ) {
    this.routeForm = this.fb.group({
      routeId: ['', Validators.required],
      // dateRange: [null, Validators.required],
      vehicleProvide: ['', Validators.required],
      numberOfVehicle: ['', Validators.required],
      maxSalary: ['', Validators.required],
      // vendorId: [null]
    });
    // this.quickCodeCategoryList = JSON.parse(localStorage.getItem('category')!);
    this.allCatagory = JSON.parse(localStorage.getItem('categoryMap')!);
    this.sendCatagoryId = this.setId();

    console.log(this.sendCatagoryId);
    this.getQuickCodeListByCategoryId(this.sendCatagoryId.toString());
    this.UserDetails = JSON.parse(localStorage.getItem('UserDetails') || '{}');

    this.accountIds = Array.from(
      new Set(this.UserDetails?.accountMapping.map((m: any) => m.accountId))
    );
    // this.getAccounts();
    // this.getVendorInfo();
    this.vehicleType();
    //  this.accountList = JSON.parse(localStorage.getItem('accountList')!);
    //  this.accountMappingList = JSON.parse(localStorage.getItem('accountMappingList')!);
    // this.getwarehouse()
    // this.getCustomer()
    console.log("data",data)
    setTimeout(() => {
      this.patchData(data);
    }, 500);
  }

  patchData(data: any) {
    this.editTrue = data?.data?.edit;
    if (data && data?.data && data?.data?.editData && data?.data?.edit) {
      if (data?.data?.editData.length === 1) {
        this.EditData = data?.data?.editData[0];
        console.log('EditData',this.EditData);
        const fromDate = moment(this.EditData?.fromDate, 'DD-MM-YYYY HH:mm:ss Z').toDate();
        const toDate = moment(this.EditData?.toDate, 'DD-MM-YYYY HH:mm:ss Z').toDate();
        const vendorIds = Array.isArray(this.EditData.accountId)
          ? this.EditData.accountId
          : [this.EditData.accountId];

        this.createForm.patchValue({
          tonnage: this.EditData?.tonnage,
          placementDate: this.EditData?.placementDate,
          materialType: this.EditData?.materialType,
          contactName: this.EditData?.contactName,
          
          contactEmail: this.EditData?.contactEmail,
          contactAlternateMobile: this.EditData?.contactAlternateMobile,
          contactMobile: this.EditData?.contactMobile,
          // customerWarehouseId: this.EditData?.customerWarehouseId,
          // placementDate: [fromDate, toDate],
          // budgetDate : moment(this.EditData.budgetDate, "DD-MM-YYYY HH:mm:ss Z").toDate(),
          // vendorId: vendorIds,
          // accountId: this.EditData?.accountName
          //   ? this.EditData?.accountName
          //   : this.customerDetails?.accountName,
          remarks: this.EditData?.remarks,
        });

        const warehouseObj =
          this.customerDetails?.accountLocationMappings?.find(
            (item: any) =>
              item.id === this.EditData?.customerWarehouseId ||
              item.warehouseCode === this.EditData?.customerWarehouseId
          );
        console.log('warehouseObj', warehouseObj);
        // if (warehouseObj) {
        //   this.createForm.patchValue({ customerWarehouseId: warehouseObj });
        // }

        this.manpowerList = this.EditData?.jobLineItems;
        // this.createForm.controls.budgetProof = this.EditData?.budgetProof.join()
      } else {
        this.EditData = data?.data?.editData;
        this.multipleEdit = true;
        this.clearFormValidators();
        this.createForm.reset();
      }
    }
  }
  getAccounts() {
    this.filters = [{ key: 'ACCOUNT_ID_IN', value: this.accountIds.join(',') }];
    this.emsServices.getAccounts(this.filters, 0, 100, 'id', 'DESC').subscribe(
      (data: any) => {
        this.customerDetails = data?.responseObject?.content[0];
        // this.createForm.patchValue({
        //   accountId: this.customerDetails?.accountName,
        // });
        console.log(this.customerDetails);

        if(this.customerDetails?.accountLocationMappings.length == 1){
          console.log("mmmm",this.customerDetails?.accountLocationMappings[0])
          const warehouseObj = this.customerDetails?.accountLocationMappings[0]
          console.log('warehouseObj', this.customerDetails?.accountLocationMappings[0]);
          // if (warehouseObj) {
          //   this.createForm.patchValue({ customerWarehouseId: warehouseObj });
          // }
        }
      },
      (err) => {
        // console.log(err);
        this.customerDetails = [];
      }
    );
  }
  onSelectWarehouseId(event: any) {
    console.log(event);
    console.log(this.editTrue)
    if(this.editTrue){
      console.log('if')

       this.createForm.patchValue({
          // cityName: event?.districtName,
          // stateName: event?.stateName,
          // pincode: event?.pincode,
          // contactName: this.EditData?.contactName,
          contactEmail: this.EditData?.contactEmail,
          contactAlternateMobile: this.EditData?.contactAlternateMobile,
          contactMobile: this.EditData?.contactMobile,
        });
    }else{
      console.log('else')
    this.createForm.patchValue({
      // cityName: event?.districtName,
      // stateName: event?.stateName,
      // pincode: event?.pincode,
      contactName: event?.pocName,
      contactMobile: event?.pocMobile,
      // contactAlternateMobile: event?.pocAddress,
    });

  }
  console.log(this.createForm.value)
  }
  clearFormValidators() {
    Object.keys(this.createForm.controls).forEach((key) => {
      this.createForm.get(key)?.clearValidators();
      this.createForm.get(key)?.updateValueAndValidity();
    });
  }
  setMonth(event: any) {
    const value = this.sharedService.formatDate(event);
    // this.createForm.controls['budgetDate'].setValue(value)
  }

  setId(): (number | undefined)[] {
    const keys = ['skillSet'];
    return keys.map((key) => this.allCatagory?.[key]?.id);
  }
  getQuickCodeListByCategoryId(ids: any) {
    this.registerService
      .getQuickCodeListByCategoryId(ids)
      .subscribe((data: any) => {
        console.log(data?.responseObject);
        this.skillSetList = data?.responseObject?.skillSet;
      });
  }
  vehicleType() {
    this.emsServices.getVehicleType([],0,500).subscribe((data: any) => {
      console.log(data?.responseObject);
      this.vehicleTypeList = data?.responseObject?.content;
    });
  }

  materialType() {
    this.service.getVendorInfo([]).subscribe((data: any) => {
      console.log(data?.responseObject);
      this.vendorInfo = data?.responseObject?.content;
    });
  }

  getVendorInfo() {
    this.service.getVendorInfo([]).subscribe((data: any) => {
      console.log(data?.responseObject);
      this.vendorInfo = data?.responseObject?.content;
    });
  }

  

  submitForm(action: 'submit' | 'draft') {
    console.log('EditDataEditData ',this.EditData , action)
    console.log(this.createForm)
    // const range: Date[] = this.createForm.value.dateRange ?? [];
    // const warehouse = this.createForm.value.customerWarehouseId;
    // const warehouseId = warehouse?.id;
    const jobCreate : any = {
      // id: this.editTrue ? this.EditData?.id : null,
      draftJobId: this.editTrue ? this.EditData?.id : null,
      // fromDate: range[0] ? moment(range[0]).format('DD-MM-YYYY HH:mm:ss +0530') : null,
      // toDate: range[1] ? moment(range[1]).format('DD-MM-YYYY HH:mm:ss +0530') : null,
      // accountId: this.customerDetails?.id,
      // customerWarehouseId: warehouseId,
      remarks: this.createForm.value.remarks,
      contactName: this.createForm.value.contactName,
      contactMobile: this.createForm.value.contactMobile,
      contactAlternateMobile: this.createForm.value.contactAlternateMobile,
      contactEmail: this.createForm.value.contactEmail,
      status: action === 'draft' ? STATUS.Draft : STATUS.Created,
    };

    const data = this.manpowerList.map(({ ...rest }) => rest);
    if (this.manpowerList.length > 0) {
      jobCreate.jobLineItems = data;
    }else{
      jobCreate.jobLineItems = [this.routeForm.value];

    }
    if(this.editTrue && this.EditData?.status == 'Created'){
       jobCreate.id = this.EditData?.id;
    }else{
      // jobCreate.jobLineItems = jobCreate.jobLineItems.map(({ id, ...rest }) => rest);
      jobCreate.jobLineItems = jobCreate.jobLineItems.map(
        ({ id, ...rest }: any) => rest
      );
    }

    // console.log('jobCreate', jobCreate);
    // console.log('manpowerList', this.manpowerList);
    // console.log('data', data);
    if(action === 'draft'){
    this.ordersService.draftAddOrUpdate(jobCreate).subscribe((data: any) => {
          if (data) {
            this.orderData = data?.responseObject;
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: this.editTrue ? 'Order updated successfully' : (action === 'draft' ? 'Draft saved successfully' : 'Order added successfully')
            })
            this.dialogRef.close(data);
          }
        });
    }else{
    this.ordersService.addOrUpdate(jobCreate).subscribe((data: any) => {
      if (data) {
        this.orderData = data?.responseObject;
         if (action === 'submit') {
          this.isOrderSubmitSuccessfully = true;
        }
        this.dialogRef.close(data);
        this._route.navigate(['/orders']);
      }
    });
     }
  }

  pushToVendor() {
    const payload = {
      id: this.editTrue ? this.EditData?.id : this.orderData?.id,
      status: STATUS.PendingOnVendor,
      vendorIds: [
        1
      ]
    }

    this.ordersService.addOrUpdate(payload).subscribe((data: any) => {
      if (data) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Order has been successfully pushed to the vendor'
        })
        this.dialogRef.close(data);
      }
    });
  }
  getSkillNameById(id: number): string {
    const skill = this.skillSetList?.find((s: any) => s.id === id);
    return skill ? skill.name : 'N/A';
  }

  onSubmit() {
    if (this.routeForm.invalid) return;

    const manpowerData = this.routeForm.value;
    // const selectedVendors = this.createForm.controls.vendorId.value ?? [];

    // if (selectedVendors.length === 0) {
    //   alert('Please select at least one vendor before adding manpower.');
    //   return;
    // }

    if (this.editIndex !== null) {
      this.manpowerList[this.editIndex] = {
        ...manpowerData,
      };
      this.editIndex = null;
    } else {
      this.manpowerList.push({
        ...manpowerData,
      });
    }

    console.log(this.manpowerList);
    this.routeForm.reset();
  }


  editRow(index: number) {
    const item = this.manpowerList[index];
    this.editIndex = index;
    this.routeForm.patchValue({
      headCount: item.headCount,
      minExperience: item.minExperience,
      skillId: item.skillId,
      maxSalary: item.maxSalary
    });

    // this.createForm.patchValue({
    //   vendorId: item.vendorIds
    // });
  }


  removeRow(index: number) {
    this.manpowerList.splice(index, 1);
    if (this.editIndex === index) {
      this.editIndex = null;
      this.routeForm.reset();
    }
  }
}